module.exports = __webpack_public_path__ + "img/icon-heat.a90fe4e9.svg";